import { CanDeactivateFn } from '@angular/router';
import { TicketingSeatsComponent } from './ticketing-seats.component';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { TicketingSeatsActions } from '../ticketing-cart.state';
import { map } from 'rxjs';

export const clearOnLeaveGuard: CanDeactivateFn<TicketingSeatsComponent> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  if (nextState.url.includes('/seats')) {
    return true;
  }
  return inject(Store)
    .dispatch(new TicketingSeatsActions.SetSeatingFilters({}))
    .pipe(map(() => true));
};
